export default __webpack_public_path__ + "static/banner-icon-959932fbe39b8a2625c9e7ff9c1745df.png";